import React, { useEffect, useState } from 'react'
import { useClaimant } from '../context/col'
import useAsync from '../hooks/useAsync'
import {
  CaseReportParamsType,
  CaseReportRespType,
  transformCaseReportRespToCaseReportParams,
  TreatmentExpensesMapRespType,
} from '../models'
import useGetData from '../hooks/useGetData'
import HealthProblemForm, {
  HealthProblemFormDataType,
} from '../components/forms/HealthProblemForm'
import { putCaseReport } from '../services/case-report/put'
import { useTreatmentExpensesProvider } from '../context/TreatmentExpensesContext'
import { sortingArray } from '../constants'

export type HealthProblemPageProps = {
  transitions: HealthProblemPageTransitions
}

export type HealthProblemPageTransitions = {
  goBack: () => void
  goToNextPage: () => void
}

const HealthProblemPage = (props: HealthProblemPageProps) => {
  const { changeTreatmentExpensesType } = useTreatmentExpensesProvider()
  const { state, dispatch } = useClaimant()
  const [ifEqual, setIfEqual] = useState<boolean>(true)
  const { fetch: fetchData, pending: loading } = useGetData({})

  React.useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /*
  const { fetch: fetchDeleteAllFiles } = useAsync({
    promiseFn: (params: any) =>
      removeAll({ data: params, id: state.caseReportId }),
  })
  */

  const handleHealthDataPageSubmitted = (
    healthDataParams: HealthProblemFormDataType
  ) => {
    const {
      loadedCaseReportResp,
    }: { loadedCaseReportResp: CaseReportRespType | undefined } = state
    //logic for save data when we klicked checkbox on HealthDatePage
    const sortedTreatmentTypes = healthDataParams?.caseME?.treatmentTypes?.sort(
      (a: string, b: string) =>
        sortingArray.indexOf(a) - sortingArray.indexOf(b)
    )
    const treatmentExpensesOrig: TreatmentExpensesMapRespType | undefined =
      loadedCaseReportResp?.caseME?.treatmentExpenses
    // treatmentExpensesRefactored = treatmentExpensesOrig,
    // ktery obsahuje pouze ty polozky, pro ktere jsme poridili TreatmentType
    const treatmentExpensesRefactored = {
      OP: {
        treatmentType: 'OP',
        costs: sortedTreatmentTypes?.includes('OP')
          ? treatmentExpensesOrig?.OP?.costs
          : [],
      },
      IP: {
        treatmentType: 'IP',
        costs: sortedTreatmentTypes?.includes('IP')
          ? treatmentExpensesOrig?.IP?.costs
          : [],
      },
      OTH: {
        treatmentType: 'OTH',
        costs: sortedTreatmentTypes?.includes('OTH')
          ? treatmentExpensesOrig?.OTH?.costs
          : [],
      },
    }

    const newCaseReportDataResp = {
      ...loadedCaseReportResp,
      // ukladam komplet caseCommon data z komponenty HealthProblemForm
      caseCommon: healthDataParams.caseCommon,
      // ukladam komplet caseME data z komponenty HealthProblemForm
      caseME: {
        ...healthDataParams.caseME,
        treatmentTypes: sortedTreatmentTypes,
        treatmentExpenses: treatmentExpensesRefactored,
      },
    } as CaseReportRespType

    // 2. Pripravena finalni data, ktera se budou odesilat
    const caseReportParamsForUpdate: CaseReportParamsType =
      transformCaseReportRespToCaseReportParams(newCaseReportDataResp)

    // 3. aktualizujeme state -- do currentCaseReportData nastavime newCaseReportDataResp
    //    a zmenime 'stranku'
    dispatch({
      type: 'update_caseReportParams',
      payload: { data: newCaseReportDataResp, page: 3 },
    })

    // 4. data posilame na server funkcí, která odesílá data na server a obsluhuje (loading+error)
    doPutCaseReport({
      caseReportId: state.caseReportId,
      caseReportParams: caseReportParamsForUpdate,
    })
  }

  useEffect(() => {
    dispatch({ type: 'control_change', payload: { controlChange: ifEqual } })
  }, [dispatch, ifEqual])

  const { fetch: doPutCaseReport, pending } = useAsync({
    promiseFn: (params: any) => putCaseReport(params),
    onData: () => {
      dispatch({ type: 'control_change', payload: { controlChange: true } })
      /*dispatch({
        type: 'update_page',
        payload: { page: 3 },
      })*/

      if (state.loadedCaseReportResp?.caseME?.treatmentTypes) {
        changeTreatmentExpensesType(
          state.loadedCaseReportResp?.caseME?.treatmentTypes[0]
        )
      }

      props.transitions.goToNextPage()
    },
    onError: (error) => {
      dispatch({ type: 'error', payload: { error: error.message } })
    },
  })

  const handleHealthDataPageBack = () => {
    props.transitions.goBack()
  }

  const healthData: HealthProblemFormDataType = {
    caseCommon: state.loadedCaseReportResp?.caseCommon ?? null,
    caseME: state.loadedCaseReportResp?.caseME ?? null,
  }

  return (
    <HealthProblemForm
      caseReportId={state.caseReportId!}
      healthData={healthData}
      onPageContinue={handleHealthDataPageSubmitted}
      onPageBack={handleHealthDataPageBack}
      errorMessage={state.error}
      isContinueInProgress={pending}
      isDataLoading={loading}
      notifyDataChanged={setIfEqual}
    />
  )
}

export default HealthProblemPage
